import { useQuery } from 'data-fetching-client';
import { GET_PRODUCTS_QUERY } from '../../../__generated__/chirp/com/hubspot/buying/rpc/ProductRpc.dfc.new';
export const useProductDetails = ({
  productApiName
}) => {
  var _productDetailsQuery$;
  const productDetailsQuery = useQuery(GET_PRODUCTS_QUERY, {
    variables: {
      productApiNames: [productApiName]
    }
  });
  const productDetails = (_productDetailsQuery$ = productDetailsQuery.data) === null || _productDetailsQuery$ === void 0 ? void 0 : _productDetailsQuery$.result.productsByName[productApiName];
  const loading = productDetailsQuery.loading;
  return {
    productDetails,
    loading
  };
};
export const useIncludedCoreSeats = ({
  productApiName
}) => {
  var _packagedQuantities$f;
  const {
    productDetails
  } = useProductDetails({
    productApiName
  });
  const packagedQuantities = productDetails === null || productDetails === void 0 ? void 0 : productDetails.packagedQuantities;
  const includedCoreSeats = packagedQuantities === null || packagedQuantities === void 0 || (_packagedQuantities$f = packagedQuantities.find(packagedQuantity => packagedQuantity.name === 'CORE_SEAT')) === null || _packagedQuantities$f === void 0 ? void 0 : _packagedQuantities$f.quantity;
  return includedCoreSeats;
};
export const useIncludedSalesSeats = ({
  productApiName
}) => {
  var _packagedQuantities$f2;
  const {
    productDetails
  } = useProductDetails({
    productApiName
  });
  const packagedQuantities = productDetails === null || productDetails === void 0 ? void 0 : productDetails.packagedQuantities;
  const includedSalesSeats = packagedQuantities === null || packagedQuantities === void 0 || (_packagedQuantities$f2 = packagedQuantities.find(packagedQuantity => packagedQuantity.name === 'SALES_SEAT')) === null || _packagedQuantities$f2 === void 0 ? void 0 : _packagedQuantities$f2.quantity;
  return includedSalesSeats;
};
export const useIncludedServiceSeats = ({
  productApiName
}) => {
  var _packagedQuantities$f3;
  const {
    productDetails
  } = useProductDetails({
    productApiName
  });
  const packagedQuantities = productDetails === null || productDetails === void 0 ? void 0 : productDetails.packagedQuantities;
  const includedServiceSeats = packagedQuantities === null || packagedQuantities === void 0 || (_packagedQuantities$f3 = packagedQuantities.find(packagedQuantity => packagedQuantity.name === 'SERVICE_SEAT')) === null || _packagedQuantities$f3 === void 0 ? void 0 : _packagedQuantities$f3.quantity;
  return includedServiceSeats;
};
export const useIncludedCommerceSeats = ({
  productApiName
}) => {
  var _packagedQuantities$f4;
  const {
    productDetails
  } = useProductDetails({
    productApiName
  });
  const packagedQuantities = productDetails === null || productDetails === void 0 ? void 0 : productDetails.packagedQuantities;
  const includedCommerceSeats = packagedQuantities === null || packagedQuantities === void 0 || (_packagedQuantities$f4 = packagedQuantities.find(packagedQuantity => packagedQuantity.name === 'COMMERCE_SEAT')) === null || _packagedQuantities$f4 === void 0 ? void 0 : _packagedQuantities$f4.quantity;
  return includedCommerceSeats;
};